import { Form, Modal, Select } from "antd"
import React, { useEffect, useState } from "react"
import Scrollbars from "react-custom-scrollbars-2"
import { useSelector } from "react-redux"
import CustomButton from "../../components/CustomButton"
import CustomEditor from "../../components/CustomEditor"
import CustomInput from "../../components/CustomInput"
import CustomSelect from "../../components/CustomSelect"

const ModalCreateHelp = ({ form, helpTags, setIsVisibleModalCreateHelp, createHelp, updateHelp, changeableHelp, setChangeableHelp }) => {
	const { tagChanged } = useSelector((state) => state.helpSectionReducer)
	useEffect(() => {
		if (changeableHelp) {
			form.setFieldsValue({
				title: changeableHelp.title,
				helpTagId: `${changeableHelp.helpTagId}`,
				content: changeableHelp.content,
				htmlText: changeableHelp.htmlText
			})
		}
	}, [changeableHelp])

	const handleOkModal = (values) => {
		if (!changeableHelp)
			createHelp(values)
		else {
			updateHelp({
				...values,
				id: changeableHelp.id
			})
		}
	}

	useEffect(() => {
		if (tagChanged)
			handleCancelModalCreateHelp()
	}, [tagChanged])

	const handleCancelModalCreateHelp = () => {
		setIsVisibleModalCreateHelp(false)
		setChangeableHelp(null)
		form.resetFields()
	}

	const setHtmlTextHelp = (htmlText, text) => {
		form.setFieldsValue({
			content: text,
			htmlText: htmlText
		})
	}

	return (<div className="create_help_wrapper">
		<Form
			form={form}
			labelAlign="left"
			labelCol={{ span: 3 }}
			style={{ width: "99%" }}
			onFinish={handleOkModal}
		>
			<Form.Item
				label="Тег"
				name="helpTagId"
				rules={[{ required: true }]}
			>
				<CustomSelect
					showSearch
					optionFilterProp="title"
					placeholder="Выберите тег"
				>
					{helpTags?.map((elem) => {
						return (
							<Select.Option
								key={elem.id}
								title={elem.name}
								disabled={Boolean(elem.isDeleted)}
							>
								{elem.name}
							</Select.Option>
						)
					})}
				</CustomSelect>
			</Form.Item>
			<Form.Item
				label="Заголовок"
				name="title"
				rules={[{ required: true }]}
			>
				<CustomInput
					maxLength={100}
					placeholder="Введите заголовок"
				/>
			</Form.Item>
			<Form.Item
				label="Содержание статьи"
				name="content"
				rules={[{ required: true, whitespace: true }]}
			>
				<div>
					<CustomEditor
						initialHtmlContent={changeableHelp?.htmlText}
						onTextChange={setHtmlTextHelp}
					/>
				</div>
			</Form.Item>
			<Form.Item name="htmlText" hidden />
			<footer className="create_help_footer">
				<CustomButton onClick={handleCancelModalCreateHelp} type="grey">Сбросить</CustomButton>
				<CustomButton htmlType="submit">Сохранить</CustomButton>
			</footer>
		</Form>
	</div>
	)
}

export default ModalCreateHelp